export const CSR_CHAT_QUERY_KEYS = {
  TOKEN: "csrChatMembersToken",
  CHANNELS: "csrChatChannels",
  MESSAGES: "csrChannelMessages",
  LIABILITY: "liability",
} as const;

export const CSR_CHAT_QUERY_RETRY = 2;

export const CSR_SOCKET_APP_ID = "1234";
export const CSR_SOCKET_RECONNECTION_ATTEMPTS = 5;
export const CSR_SOCKET_TIMEOUT_MS = 4000;
export const CSR_SOCKET_USER_ROLE = "member";
export const CSR_SOCKET_USER_TYPE = "user";

export const CSR_ROLE_MEMBER = "member" as const;
export const CSR_ROLE_CSR = "csr" as const;
export const CSR_ROLE_BOT = "bot" as const;

export const CSR_MESSAGE_STATUS_SEEN = "seen" as const;

export const CSR_TYPING_IDLE_MS = 3000;
export const CSR_TYPING_DEBOUNCE_MS = 500;

export const CSR_MESSAGE_GROUP_THRESHOLD_MS = 60_000;

export const CSR_BOT_REPLY_YES = "Yes" as const;
export const CSR_BOT_REPLY_NO = "No" as const;

export const CSR_CHANNEL_STATUS_CLOSED = "closed" as const;

export const CSR_MESSAGE_TYPE = {
  INFO: "info",
};
